import { useEffect, useState } from "react";
import { userData } from "../js/utils";
import { post } from "../js/post";

export function useOptics() {
  const [opticList, setOpticList] = useState([]);

  async function getOptics() {
    const response = await post("ListarOpticas.php", {
      token: userData.token,
    });
    setOpticList([
      ...response.map((e) => ({
        id: e.id,
        text: e.nombre,
        smallText: e.nombreCorto,
      })),
    ]);
  }

  useEffect(() => {
    getOptics();
  }, []);

  return opticList;
}
